import { useState } from 'react';

const useToggle = (initiallyOpen, onToggle) => {
  const [isOpen, setOpen] = useState(initiallyOpen);

  const toggle = () => {
    setOpen(!isOpen);
    onToggle && onToggle();
  };

  const open = () => {
    setOpen(true);
  };

  const close = () => {
    setOpen(false);
  };

  return { isOpen, toggle, open, close };
};

export default useToggle;
